import React from 'react';
import {useSelector} from 'react-redux';


import {userSelectors} from '../../User';

import PublicationImage from '../PublicationImage';


function OwnPublicationImage({}) {

    const publication = useSelector(userSelectors.getPublication);
    if (!publication) {

        return null;
    }

    return (
        <PublicationImage
            imageUrl={publication.imageUrl}
            name={publication.name}
        />
    );
}


OwnPublicationImage.propTypes = {};


export default OwnPublicationImage;
